import { render } from "./Exhibitions.vue?vue&type=template&id=60f4dc55&scoped=true"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"

import "./Exhibitions.vue?vue&type=style&index=0&id=60f4dc55&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f4dc55"]])

export default __exports__